
import { getClerkPermissionForNavigation } from '@/utils/clerkPermissionMapper';
import { isAgentWithLimitedAccess } from '@/utils/navigationPermissions';
import {
  Home,
  Inbox,
  Users,
  Bot,
  BarChart,
  Settings,
  AtSign,
  ListFilter,
  InboxIcon,
  UsersRound,
  User,
  Building2,
  BrainCircuit,
  ScrollText,
  FileSpreadsheet,
  UserCog,
  MessagesSquare,
  Mail,
  Database,
  Tags,
  MessageCircle,
  Reply,
  Brain,
  Activity,
  MessageSquare,
  Globe,
  Monitor,
  LayoutDashboard,
  FileText,
  BarChart3
} from 'lucide-react';

export interface NavItem {
  id: string;
  title: string;
  icon: any;
  path: string;
  permissionKey?: string;
  children?: NavItem[];
  loadDynamicChildren?: boolean;
}

export const mainNavItems: NavItem[] = [
  { id: 'home', title: 'Home', icon: Home, path: '/home', permissionKey: 'home' },
  { id: 'inbox', title: 'Inbox', icon: Inbox, path: '/home/inbox', permissionKey: 'inbox' },
  { id: 'contacts', title: 'Contacts', icon: Users, path: '/home/contacts/all', permissionKey: 'contacts' },
  { id: 'automation', title: 'AI & Automation', icon: Bot, path: '/home/automation', permissionKey: 'automation' },
  { id: 'autoqa', title: 'AutoQA', icon: Brain, path: '/home/autoqa', permissionKey: 'settings.autoqa' },
  { id: 'reporting', title: 'Reporting', icon: BarChart, path: '/home/reporting', permissionKey: 'reporting' },
  { id: 'settings', title: 'Settings', icon: Settings, path: '/home/settings', permissionKey: 'settings' }
];

export const subNavItems = {
  inbox: [
    { title: 'Your Inbox', icon: InboxIcon, path: '/home/inbox/your-inbox', permissionKey: 'inbox.your-inbox' },
    { title: 'Mentions', icon: AtSign, path: '/home/inbox/mentions', permissionKey: 'inbox.mentions' },
    { title: 'All', icon: ListFilter, path: '/home/inbox/all', permissionKey: 'inbox.all' },
    { title: 'Unassigned', icon: MessageSquare, path: '/home/inbox/unassigned', permissionKey: 'inbox.unassigned' },
    {
      title: 'Teams',
      icon: UsersRound,
      children: [],
      loadDynamicChildren: true,
      permissionKey: 'inbox.teams'
    },
    {
      title: 'Bot Inboxes',
      icon: Bot,
      children: [],
      loadDynamicChildren: true,
      permissionKey: 'inbox.bot-inboxes'
    }
  ],
  contacts: [
    {
      title: 'Contacts',
      icon: Users,
      permissionKey: 'contacts.all',
      children: [
        { title: 'All Contacts', path: '/home/contacts/all', permissionKey: 'contacts.all' },
        { title: 'Visitors', path: '/home/contacts/visitors', permissionKey: 'contacts.visitors' },
        { title: 'Customers', path: '/home/contacts/customers', permissionKey: 'contacts.customers' }
      ]
    },
    { title: 'Companies', icon: Building2, path: '/home/contacts/companies', permissionKey: 'contacts.companies' }
  ],
  automation: [
    {
      title: 'AI',
      icon: BrainCircuit,
      permissionKey: 'automation.content-center',
      children: [
        { title: 'Content Center', path: '/home/automation/ai/content-center', permissionKey: 'automation.content-center' },
        { title: 'Chatbot Profiles', path: '/home/automation/ai/chatbot-profiles', permissionKey: 'automation.chatbot-profiles' },
        { title: 'Action Center', path: '/home/automation/ai/action-center', permissionKey: 'automation.action-center' },
        { title: 'Copilot', path: '/home/automation/ai/copilot', permissionKey: 'automation.copilot' }
      ]
    },
    {
      title: 'Workflows',
      icon: ScrollText,
      path: '/home/automation/workflows',
      permissionKey: 'automation.workflows',
      // children: [
      //   { title: 'All Workflows', path: '/home/automation/workflows', permissionKey: 'automation.workflows' },
      //   { title: 'Templates', path: '/home/automation/workflow-templates', permissionKey: 'automation.workflow-templates' }
      // ]
    }
  ],
  reporting: [
    { title: 'Dashboard', icon: LayoutDashboard, path: '/home/reporting/dashboard', permissionKey: 'reporting.dashboard' },
    // { title: 'Ticket Analytics', path: '/home/reporting/tickets', permissionKey: 'reporting.tickets' },
    // { title: 'Agent Performance', path: '/home/reporting/agents', permissionKey: 'reporting.agents' },
    // { title: 'Customer Insights', path: '/home/reporting/customers', permissionKey: 'reporting.customers' },
    // { title: 'Channel Analytics', path: '/home/reporting/channels', permissionKey: 'reporting.channels' },
    // { title: 'SLA Reports', path: '/home/reporting/sla', permissionKey: 'reporting.sla' },
    {
      title: 'Predefined Reports',
      icon: FileText,
      path: '/home/reporting/ticket-analytics',
      permissionKey: 'reporting.reports',
      children: [
        { title: 'Tickets', path: '/home/reporting/ticket-analytics', permissionKey: 'reporting.reports' },
        { title: 'Effectiveness', path: '/home/reporting/effectiveness', permissionKey: 'reporting.reports' },
        { title: 'AI Chatbots', path: '/home/reporting/ai-chatbots', permissionKey: 'reporting.reports' },
        { title: 'AI Copilot', path: '/home/reporting/ai-copilot', permissionKey: 'reporting.reports' },
        { title: 'Responsiveness', path: '/home/reporting/responsiveness', permissionKey: 'reporting.reports' },
        { title: 'CSAT', path: '/home/reporting/csat', permissionKey: 'reporting.reports' },
        { title: 'Team Performance', path: '/home/reporting/team-performance', permissionKey: 'reporting.reports' },
        { title: 'Teammate Performance', path: '/home/reporting/teammate-performance', permissionKey: 'reporting.reports' },
      ]
    },
    // { title: 'Custom Reports', icon: BarChart3, path: '/home/reporting/custom', permissionKey: 'reporting.custom' },
  ],
  autoqa: [
    { title: 'Supervisor Cockpit', icon: Monitor, path: '/home/autoqa/supervisor-cockpit', permissionKey: 'settings.autoqa' },
    { title: 'My Scorecards', icon: FileText, path: '/home/autoqa/my-scorecards', permissionKey: 'settings.autoqa' },
    { title: 'Teammate Scorecards', icon: Users, path: '/home/autoqa/teammate-scorecards', permissionKey: 'settings.autoqa', loadDynamicChildren: true },
    { title: 'Team Performance', icon: BarChart3, path: '/home/autoqa/team-performance', permissionKey: 'settings.autoqa' }
  ],
  settings: [
    { title: 'General Settings', icon: Settings, path: '/home/settings/general', permissionKey: 'settings.general' },
    { title: 'Ticket Settings', icon: MessageSquare, path: '/home/settings/tickets', permissionKey: 'settings.tickets' },
    { title: 'Teams', icon: Users, path: '/home/settings/teams', permissionKey: 'settings.teams' },
    { title: 'Chat', icon: MessagesSquare, path: '/home/settings/chat', permissionKey: 'settings.chat' },
    {
      title: 'Email',
      icon: Mail,
      permissionKey: 'settings.email',
      children: [
        { title: 'Domains', path: '/home/settings/email/domains', permissionKey: 'settings.email' },
        { title: 'Manage Channels', path: '/home/settings/email/channels', permissionKey: 'settings.email' }
      ]
    },
    { title: 'Custom Objects', icon: Database, path: '/home/settings/custom-objects', permissionKey: 'settings.custom-objects' },
    { title: 'Data Model', icon: Database, path: '/home/settings/custom-data', permissionKey: 'settings.custom-data' },
    { title: 'Tags', icon: Tags, path: '/home/settings/tags', permissionKey: 'settings.tags' },
    // { title: 'Topics', icon: MessageCircle, path: '/home/settings/topics', permissionKey: 'settings.topics' },
    { title: 'Canned Responses', icon: Reply, path: '/home/settings/canned-responses', permissionKey: 'settings.canned-responses' },
    // { title: 'Sentiment', icon: Activity, path: '/home/settings/sentiment', permissionKey: 'settings.sentiment' },
    { title: 'AutoQA', icon: Brain, path: '/home/settings/autoqa', permissionKey: 'settings.autoqa' },
    { title: 'Auto Reply', icon: Reply, path: '/home/settings/auto-reply', permissionKey: 'settings.auto-reply' },
    { title: 'Notifications', icon: Mail, path: '/home/settings/email-templates', permissionKey: 'settings.email-templates' },
  ]
};

// 🎯 Agent-specific navigation items
export const getAgentAllowedInboxItems = () => {
  return [
    { title: 'Your Inbox', icon: InboxIcon, path: '/home/inbox/your-inbox', permissionKey: 'inbox.your-inbox' },
    { title: 'Mentions', icon: AtSign, path: '/home/inbox/mentions', permissionKey: 'inbox.mentions' },
    // { title: 'Teams', icon: UsersRound, path: '/home/inbox/teams', permissionKey: 'inbox.teams' }
  ];
};

// 🔧 Safe filter function with error handling - now uses Clerk permissions
export const getFilteredMainNavItems = (): NavItem[] => {
  try {
    if (isAgentWithLimitedAccess()) {
      // For agents, only show inbox
      return mainNavItems.filter(item => item.id === 'inbox');
    }

    // For other roles, return all items - Clerk's Protect will handle permission checking
    return mainNavItems;
  } catch (error) {
    console.error("Error filtering main nav items:", error);
    // Fallback - show only inbox for safety
    return mainNavItems.filter(item => item.id === 'inbox');
  }
};

// 🔧 Safe sub navigation filter - now uses Clerk permissions
export const getFilteredSubNavItems = (activeMainNav: string) => {
  try {
    if (isAgentWithLimitedAccess() && activeMainNav === 'inbox') {
      return getAgentAllowedInboxItems();
    }

    const subItems = subNavItems[activeMainNav as keyof typeof subNavItems] || [];
    return subItems; // Return all items - Clerk's Protect will handle permission checking
  } catch (error) {
    console.error("Error filtering sub nav items:", error);
    // Fallback for agents
    if (activeMainNav === 'inbox') {
      return getAgentAllowedInboxItems();
    }
    return [];
  }
};

// // Helper function to wrap navigation items with Clerk's Protect
// export const wrapNavItemWithProtect = (item: NavItem, children: React.ReactNode) => {
//   if (!item.permissionKey) {
//     return children;
//   }

//   const clerkPermission = getClerkPermissionForNavigation(item.permissionKey);

//   return (
//     <Protect permission= { clerkPermission } fallback = {<> </>
// }>
//   { children }
//   </Protect>
//   );
// };

// Helper function to filter navigation items based on permissions - now uses Clerk
export const filterNavItemsByPermissions = (items: any[]): any[] => {
  return items; // Return all items - Clerk's Protect will handle permission checking
};
